import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ModuleTypes } from "src/app/modules/settings/enums/moduleTypes";
import { DepartmentVisibilities } from "src/app/modules/shared/enums/departmentVisibility.enum";
import { EmployeeRoleTypes } from "src/app/modules/shared/enums/employees/EmployeeRoleTypes";
import { FilterTypes } from "src/app/modules/shared/enums/filterTypes";
import { ObjectTypes } from "src/app/modules/shared/enums/objectTypes";
import { LocalisationService } from "src/app/modules/shared/services/localisation.service";
import { EmployeeUtil } from "src/app/modules/shared/utilities/employee.utilities";
import { EmployeeDetailsViewModel } from "src/app/modules/shared/viewModels/employeeDetailsViewModel";
import { PermissionViewModel } from "src/app/modules/shared/viewModels/permissionViewModel";
import { T } from 'src/assets/i18n/translation-keys';
import { ReadWriteTypes } from "src/app/modules/settings/enums/readWriteTypes";
import { PermissionHelper } from "src/app/modules/settings/utils/permission.helper";

@Component({
    selector: 'app-employee-permissions-section',
    templateUrl: './employee-permissions-section-component.html',
    styleUrls: ['./employee-permissions-section-component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class EmployeePermissionsSectionComponent implements OnInit {
  @Input() public employee: EmployeeDetailsViewModel;
  @Input() public filterType: FilterTypes;
  @Input() public module: ModuleTypes
  @Input() public isInPrimaryRole: boolean;
  @Input() public isDepartmentSelected: boolean;
  @Input() managerRole: EmployeeRoleTypes;

  @Output() permissionsChanged = new EventEmitter<PermissionViewModel[]>();

  public readonly departmentVisibilites = DepartmentVisibilities;
  public readonly T = T;
  public readonly employeeRoleTypes = EmployeeRoleTypes;
  public readWriteTypes = ReadWriteTypes;
  public readNonConfidentialDepVisibility: DepartmentVisibilities;
  public writeNonConfidentialDepVisibility: DepartmentVisibilities;
  public localisedEmployee = 'Employee';
  public localisedDepartment = 'Department';
  public localisedDepartments = 'Departments';
  public localisedItem = 'Item';
  public localisedItems = 'Items';


  constructor(private readonly translateService: TranslateService,
              private readonly localisationService: LocalisationService) {}

  ngOnInit() {
    this.localisedEmployee = this.localisationService.localiseObjectType(ObjectTypes.Employee);
    this.localisedDepartment = this.localisationService.localiseObjectType(ObjectTypes.Department);
    this.localisedDepartments = this.localisationService.localiseObjectType(ObjectTypes.Department, true);
    this.localisedItem = this.localisationService.localiseFilterType(this.filterType);
    this.localisedItems = this.localisationService.localiseFilterType(this.filterType, true);

    this.readNonConfidentialDepVisibility = this.getDepartmentVisibility(this.readWriteTypes.read);
    this.writeNonConfidentialDepVisibility = this.getDepartmentVisibility(this.readWriteTypes.write);
  }

  getDepartmentVisibility(readOrWrite: ReadWriteTypes, confidential = false) {
    return PermissionHelper.getDepartmentVisibility(this.employee, readOrWrite, this.filterType, this.module, confidential);
  }

  changeDepartmentVisibility(
    currentDepVisibility: DepartmentVisibilities,
    readOrWrite: ReadWriteTypes,
    confidential = false
  ) {

    PermissionHelper.changeDepartmentVisibility(this.employee, currentDepVisibility, this.module, this.filterType, readOrWrite, confidential);
    console.log(currentDepVisibility);
    console.log(this.employee.permissions);
    this.initDepartmentVisibilities();
  }

  private initDepartmentVisibilities() {
    this.readNonConfidentialDepVisibility = this.getDepartmentVisibility(this.readWriteTypes.read);
    this.writeNonConfidentialDepVisibility = this.getDepartmentVisibility(this.readWriteTypes.write);
    console.log('Department visibilities initialized:', this.readNonConfidentialDepVisibility, this.writeNonConfidentialDepVisibility);
  }

  isInRole(employeeRole: EmployeeRoleTypes) {
    return EmployeeUtil.hasRole(this.employee, employeeRole);
  }
}
